import { type ProspectDto } from "@crowdcoursing/api/openapi";
import { useState } from "react";

import { useToast } from "~hooks/useToast";

import { useProspectDetails } from "./useProspectDetails";

export const useNoteModal = (prospectId: string) => {
  const toast = useToast();
  const { addNewNote, updateExistingNote, deleteNote } = useProspectDetails(prospectId);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [editNote, setEditNote] = useState<NonNullable<ProspectDto["notes"]>[number] | null>(null);
  const [noteToDelete, setNoteToDelete] = useState<NonNullable<ProspectDto["notes"]>[number] | null>(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);

  const handleAddNote = async (values: { body: string; pinned: boolean }) => {
    try {
      await addNewNote(values);
      setIsAddOpen(false);
      toast.success("Note added successfully");
    } catch (error) {
      console.error("Error adding note:", error);
      toast.error("Failed to add note");
    }
  };

  const handleUpdateNote = async (values: { body: string; pinned: boolean }) => {
    if (!editNote?.id) {
      return;
    }

    try {
      await updateExistingNote(editNote.id, values);
      setEditNote(null);
      toast.success("Note updated successfully");
    } catch (error) {
      console.error("Error updating note:", error);
      toast.error("Failed to update note");
    }
  };

  const handleDeleteNote = async () => {
    if (!noteToDelete?.id) {
      return;
    }

    try {
      await deleteNote(noteToDelete.id);
      setNoteToDelete(null);
      setDeleteConfirmOpen(false);
      toast.success("Note deleted successfully");
    } catch (error) {
      console.error("Error deleting note:", error);
      toast.error("Failed to delete note");
    }
  };

  const handlePinToggle = async (note: NonNullable<ProspectDto["notes"]>[number]) => {
    try {
      await updateExistingNote(note.id ?? "", {
        body: note.body ?? "",
        pinned: !note.pinned,
      });
      toast.success(`Note ${note.pinned ? "unpinned" : "pinned"} successfully`);
    } catch (error) {
      console.error("Error toggling pin:", error);
      toast.error("Failed to toggle pin");
    }
  };

  const openAddModal = () => setIsAddOpen(true);
  const closeAddModal = () => setIsAddOpen(false);
  const openEditModal = (note: NonNullable<ProspectDto["notes"]>[number]) => setEditNote(note);
  const closeEditModal = () => setEditNote(null);
  const openDeleteModal = (note: NonNullable<ProspectDto["notes"]>[number]) => {
    setNoteToDelete(note);
    setDeleteConfirmOpen(true);
  };
  const closeDeleteModal = () => {
    setDeleteConfirmOpen(false);
    setNoteToDelete(null);
  };

  return {
    
    closeAddModal,
    
closeDeleteModal,
    
closeEditModal,
    
deleteConfirmOpen,
    
    
editNote,
    

// Form handlers
handleAddNote,
    


handleDeleteNote,
    


handlePinToggle,
    


handleUpdateNote,
    

// Modal states
isAddOpen,
    
    
noteToDelete,
    // Modal actions
openAddModal,
    openDeleteModal,
    openEditModal,
  };
};
